<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="500"
      scrollable
    >
      <v-card>
        <v-toolbar color="primary" flat>
          <v-toolbar-title class="text--contrast">Запись</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn class="text--contrast"
                   icon
                   @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="black--text show-scrollbar pt-4 pb-2 pb-sm-4">
          <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            absolute
            bottom
            color="primary"
          ></v-progress-linear>

          <v-select
            :items="selectFilials"
            v-model="filialId"
            item-text="name"
            item-value="id"
            label="Филиал"
            ref="filial"
            v-if="showSelects"
            @change="changeFilial"
          ></v-select>

          <v-select
            :items="selectClasses"
            v-model="cl"
            item-text="displayName"
            return-object
            label="Группа"
            ref="classes"
            v-if="showSelects"
            @change="classChange"
          >
            <template v-slot:item="{ item }">
              {{ item.displayName }}
              <span class="body-2 ml-1 grey--text" v-if="item.freeRecords!==null">
                (ост. {{ item.freeRecords }} мест)</span>
            </template>

          </v-select>

          <v-alert outlined type="warning" v-if="showNoNeedToPayReasonAlert" class="body-2">
            <template v-if="existingJoin">
              Вы записаны в данную группу. Ваш статус:
              <span v-if="existingJoin.status==='study'" class="primary--text">Занимается</span>
              <span v-if="existingJoin.status==='over'" class="red--text">Завершил/отказался</span>.
            </template>
            <template v-else-if="hasActiveSubscriptionForClass">
              У вас есть активный абонемент для данной группы.
            </template>

            <template v-if="canSelectLessons">
              <span v-if="cl.courseId === 0">Вы можете записаться на занятие:</span>
              <span v-else-if="cl.courseId !== 0 && lessons.length">Вы можете выбрать занятия.</span>
            </template>
          </v-alert>

          <v-col align="start center" v-if="cl && cl.courseId === 0 && canSelectLessons" dense>
            <h2 class="body-2" v-if="showSelectsInterval">
              Выберите длительность занятия:
            </h2>

            <v-radio-group row v-if="showSelectsInterval"  @change="changeInterval" v-model="individualData.interval">
              <v-radio
                v-for="n in durationIntervals"
                :key="n"
                :label="`${n} мин`"
                :value="n"
              ></v-radio>
            </v-radio-group>


            <v-col>
              <v-row justify="space-between" class="flex-wrap" align="baseline">
                <v-col align="left" class="pa-0">
                  <h2 class="body-2" v-if="!individualData.teacherId">
                    Выберите преподавателя:
                  </h2>
                  <h2 v-if="individualData.teacherId && !completeIndividual" class="body-2">
                    Выберите время записи:
                  </h2>
                  <h2 v-if="completeIndividual" class="body-2">
                    Вы выбрали: <span class="primary--text break-word">
                    {{ selectedTeacherInfo }}
                  </span>
                  </h2>
                </v-col>

                <v-col align="right" class="pa-0">
                  <v-btn color="primary" v-if="canSkipTeachers"
                         text
                         :disabled="!managersLoaded"
                         @click="skipTeachers">
                    Пропустить
                  </v-btn>
                  <v-btn color="primary" v-if="individualData.teacherId && showBackButton"
                         text
                         @click="goBack">
                    Назад
                  </v-btn>
                </v-col>

                <p class="font-weight-light mt-3 mb-0" v-if="completeIndividual
                  || (!completeIndividual && individualData.teacherId)">
                  {{ filialTzText }}
                </p>
              </v-row>
            </v-col>

            <div :class="(managersLoaded) ? '' : 'min-height'">
              <v-list
                expand
                v-if="!individualData.teacherId && managersLoaded"
                class="pa-0"
                id="teacher-selector">
                <v-list-item-group v-model="selectedTeacherId">
                  <lesson-teacher-list-item
                    v-for="(teacher, i) of managers"
                    :class="(i === managers.length - 1 ? '' : 'mb-4')"
                    :key="teacher.id" :teacher="teacher"
                    :selected-teacher-id="selectedTeacherId">
                  </lesson-teacher-list-item>
                </v-list-item-group>
              </v-list>

              <v-progress-linear :active="!managersLoaded" indeterminate color="primary">
              </v-progress-linear>

              <v-col v-if="!managers.length && managersLoaded && cl.allowRecords">
                <v-alert outlined type="warning" class="body-2">
                  К сожалению, нет доступных преподавателей для записи
                </v-alert>
              </v-col>
            </div>

              <v-col justify="center" class="pa-0" v-if="individualData.teacherId
              && !completeIndividual">
                <v-date-picker
                  class="mt-4"
                  first-day-of-week="1"
                  full-width
                  :allowed-dates="individualAllowedDates"
                  v-model="selectedIndividualDate"
                  @change="changeSelectedDate($event)"
                ></v-date-picker>
                <v-list
                expand
                id="free-time-selector"
                v-if="freeTimeDate.length && !individualData.time && individualData.teacherId">
                  <v-list-item-group class="free-time-container" v-model="selectedIndividualTime">
                        <v-list-item active-class="primary"
                                     class="lighten-4 grey free-time-item mt-3"
                                     :key="i"
                                     :disabled="!canRecordThisTime(item)"
                                     dense
                                     v-for="(item, i) of freeTimeDate">
                          <div class="free-time-item-content">
                            <v-list-item-title class="break-word">
                              {{ item.time }}
                            </v-list-item-title>

                            <v-list-item-subtitle class="break-word mb-1" v-if="individualData.teacherId === -1">
                              {{ getTeacherName(item.teacherId) }}
                            </v-list-item-subtitle>
                          </div>
                        </v-list-item>
                  </v-list-item-group>
                </v-list>
                <v-alert v-else-if="!freeTimeDate.length" outlined type="warning" class="body-2">
                  К сожалению, у преподавателей нет свободного времени
                </v-alert>
              </v-col>
          </v-col>

          <v-col v-if="cl && cl.courseId !== 0">
            <v-row align="center" v-if="cl && canSelectLessons && lessons.length" dense>
              <v-col>
                <h2 class="body-1">Выберите занятия
                  <span v-if="lessonIds.length>0">(<span
                    class="primary--text">выбрано {{ lessonIds.length }}</span>):</span>
                </h2>
              </v-col>
              <v-col align="right" cols="2">
                <v-menu
                  ref="dateSelector"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn icon height="30" small class="mb-0" v-on="on">
                      <v-icon>mdi-calendar</v-icon>
                    </v-btn>
                  </template>
                  <v-date-picker
                    first-day-of-week="1"
                    :min="selectDateMin"
                    :max="selectDateMax"
                    :allowed-dates="allowedDates"
                    v-model="selectedDate"
                    @change="moveDate($event)"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-list
              v-if="cl && canSelectLessons && lessons.length"
              expand
              subheader
              v-bind:class="{'mb-4': isShowPriceInfo }"
              id="join-lesson-selector">

              <v-list-item-group v-model="lessonIds" multiple>
                <div v-for="group of groupedLessons"
                     :key="group.id"
                     :id="'lesson-date-'+group.date">

                  <v-list-item-subtitle class="mb-1 mt-2">
                    {{ group.displayDate }}
                  </v-list-item-subtitle>
                  <lesson-list-item v-for="lesson of group.lessons"
                                    :key="lesson.id"
                                    :lesson="lesson"></lesson-list-item>
                </div>
              </v-list-item-group>
            </v-list>
          </v-col>

          <div v-if="getPaymentFieldsVisibility">
            <v-checkbox
              v-if="clOnlinePaymentForJoin === 'possibleWithoutPayment'"
              v-model="notPayNow"
              :label="'Пока не оплачивать'"
              class="mt-0 mb-3"
              hide-details>
            </v-checkbox>

            <v-select
              v-if="selectSubscriptionTypes.length"
              :items="selectSubscriptionTypes"
              v-model="subscriptionType"
              @change="changeSubscriptionType"
              item-text="displayName"
              return-object
              label="Абонемент"
            ></v-select>

            <h2
              v-if="isShowSubscriptionBeginDateSelect && !notPayNow"
              class="body-1">
              Начало действия абонемента
            </h2>

            <v-radio-group
              v-if="isShowSubscriptionBeginDateSelect"
              required v-model="subscriptionStartDate">
              <v-radio
                :label="'Со следующего месяца'"
                :value="'fromNextMonth'"
              ></v-radio>
              <v-radio
                :label="'С начала текущего месяца'"
                :value="'fromThisMonth'"
              ></v-radio>
              <v-radio
                :label="'С текущей даты'"
                :value="'fromNow'"
              ></v-radio>
            </v-radio-group>

            <h2
              v-if="Number.isInteger(joinDiscount) && isShowPriceInfo"
              class="body-1">
              Скидка:
              <money :sum="joinDiscount" color-class="primary--text"></money>
            </h2>

            <v-alert outlined type="warning" v-if="maxDiscount && userDiscount >= maxDiscount" class="body-2 mt-5">
              Максимальная скидка ограничена настройками абонемента/группы в {{ maxDiscount }}%.
            </v-alert>

            <v-text-field
              class="mt-5"
              v-if="isShowPaymentSumInput"
              v-model="summa"
              :label="paymentSumLabel"
              :placeholder="String(joinPriceLimits.max)"
              type="number"
              min="1">
            </v-text-field>

            <div v-if="showBonuses" class="grey lighten-3 pt-3 pl-2 mb-5 pb-3">
              <h2 class="body-1">
                {{ 'bonuses' | lang }}:
                <money color-class="primary--text" :hide-currency="true" :sum="currentUser.bonusBalance">
                </money>
              </h2>
              <span class="caption grey--text">Можно списать: {{ availableBonuses }}</span>

              <div class="mc-bonuses-block">
                <v-checkbox
                  v-if="currentUser.bonusBalance"
                  v-model="debitBonuses"
                  :label="'Списать бонусы'"
                  hide-details>
                </v-checkbox>

                <v-text-field
                  v-if="debitBonuses"
                  v-model="bonusesSumma"
                  class="mb-2 mc-bonuses-sum"
                  :label="'Сумма'"
                  :placeholder="String(availableBonuses)"
                  type="number"
                  max="availableBonuses"
                  min="0">
                </v-text-field>
              </div>

            </div>


            <div class="grey lighten-3 pt-3 pl-2 mb-5 pb-3"
                 v-if="isOnlinePaymentEnabled && !notPayNow">
              <h2 class="body-1">
                Баланс:
                <money :sum="currentUser.availableBalance" color-class="primary--text"></money>
              </h2>

              <v-checkbox
                v-if="currentUser.availableBalance"
                v-model="debitFromBalans"
                :label="'Списать средства с баланса'"
                hide-details>
              </v-checkbox>
            </div>

            <h2
              v-if="isOnlinePaymentEnabled && !notPayNow"
              v-bind:class="{'mt-2': !cl.onlinePayment.partialPaymentForNewJoin}"
              class="body-1">
              Итого к оплате:
              <money :sum="totalSum" color-class="primary--text"></money>
            </h2>

            <h2
              v-if="isShowPriceInfo && (!isOnlinePaymentEnabled || notPayNow)"
              class="body-1 mt-2">
              Итого цена:
              <money :sum="totalSum" color-class="primary--text"></money>
            </h2>

            <v-select
              class="mt-4"
              v-if="isShowIntegrationSelect"
              :items="onlinePaymentIntegrationsSelect"
              v-model="integrationId"
              item-text="name"
              item-value="id"
              hide-details
              label="Платежная система"
            >
            </v-select>
          </div>
        </v-card-text>
        <v-card-actions class="align-center justify-center flex-wrap">
          <v-btn text @click="dialog=false">Отменить</v-btn>
          <v-btn text v-if="!cl" class="accent-btn text--secondary"
                 disabled>Записаться</v-btn>
          <div v-if=" cl && cl.courseId === 0 && canSelectLessons">
            <v-btn v-if="!completeIndividual" color="accent" text @click="nextIndividualStep"
                   class="accent-btn" :class="{'text--secondary':disableNextButton}"
                   :disabled="disableNextButton">
              Продолжить
            </v-btn>
          </div>
          <div v-if="getButtonsCond">
            <v-btn
              text
              v-if="clOnlinePaymentForJoin === 'combined'"
              class="accent-btn"
              :class="{'text--secondary':!canJoinAndPay || loading}"
              color="accent"
              @click="payForJoin"
              :disabled="!canJoinAndPay || loading"
            >
              {{ payForJoinBtnText }}
            </v-btn>
            <v-btn
              text
              v-else-if="clOnlinePaymentForJoin === 'possibleWithoutPayment' && !notPayNow"
              class="ml-0 ml-sm-2 accent-btn"
              color="accent"
              :class="{'text--secondary':!canJoinAndPay || loading}"
              @click="createJoinAndPay"
              :disabled="!canJoinAndPay || loading"
            >
              {{ createJoinAndPayBtnText }}
            </v-btn>
            <v-btn
              text
              v-else
              class="ml-0 ml-sm-2 accent-btn"
              color="accent"
              :class="{'text--secondary':!canJoin || loading}"
              @click="createJoin"
              :disabled="!canJoin || loading"
            >
              Записаться
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openLinkDialog" width="500">
      <v-card>
        <v-card-text class="black--text show-scrollbar pt-4 pb-2 pb-sm-4">
          Сейчас вы будете перенаправлены на страницу оплаты.
        </v-card-text>
        <v-card-actions class="align-center align-center justify-center flex-wrap">
          <v-btn color="accent" text @click="closeOpenLink()">ОК</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="errorJoin" top right color="error">
      Запись невозможна. Пожалуйста, обновите страницу
    </v-snackbar>
  </div>

</template>

<script>
import moment from 'moment-timezone';
import { mapGetters, mapMutations } from 'vuex';
import * as _ from 'lodash';
import Join from '../../api/Join';
import Lesson from '../../api/Lesson';
import loadBaseInfo from '../../lib/baseInfoHelpers';
import { getClassName, checkAllowRecord } from '@/lib/classHelpers';
import LessonListItem from '../lessons/LessonListItem.vue';
import LessonTeacherListItem from '../lessons/LessonTeacherListItem.vue';
import {
  getDisplayName,
  noop,
  getSubscriptionForPayment,
} from '@/lib/subscriptionHelpers';
import Payment from '@/api/Payment';
import store from '@/store';
import Money from '@/components/Money.vue';
import { getMoneyStr } from '@/lib/moneyHelpers';
import Manager from '../../api/Manager';
import LessonRecord from '../../api/LessonRecord';
import langFilter from '../../filters/langFilter';
import { getUserMobileAgent } from '@/lib/mobileHelper';
import {
  calculateDiscount,
  getAvailableBonusesSum,
  isValidEntityForBPLevel,
} from '@/lib/bonusProgramHelper';
import { initPaymentProcess } from '@/lib/paymentHelper';
import DateHelper from '../../lib/dateHelper';

moment.locale(store.getters.lang);

function getLessonsWord(lessonsCount) {
  if ((lessonsCount >= 5 && lessonsCount <= 20) || lessonsCount === 0) {
    return 'занятий';
  }
  const mod = lessonsCount % 10;
  if (mod === 1) {
    return 'занятие';
  }
  if (mod >= 2 && mod <= 4) {
    return 'занятия';
  }
  return 'занятий';
}


export default {
  name: 'CreateJoinDialog',
  components: { Money, LessonListItem, LessonTeacherListItem },
  props: ['value'],
  data: () => ({
    openLinkDialog: false,
    filialId: null,
    steps: 3,
    e1: 1,
    cl: null,
    lessonIds: [],
    loading: false,
    errorJoin: false,
    lessonLoading: false,
    teachersFreeTime: [],
    groupedLessons: [],
    showSelects: true,
    managers: [],
    managersLoaded: false,
    allowedDatesIndividual: [],
    subscriptionType: null,
    integrationId: null,
    debitBonuses: false,
    availableBonuses: null,
    bonusesSumma: null,
    showBonuses: false,
    debitFromBalans: false,
    selectedTeacherId: null,
    notPayNow: false,
    summa: undefined,
    freeTimeDate: [],
    prevSelectedTeacherId: null,
    completeIndividual: false,
    individualData: {
      teacherId: null,
      date: null,
      time: null,
    },
    lessons: [],
    selectedIndividualDate: null,
    frozenDates: [],
    selectMaxDateIndividual: moment().add(6, 'month').format('YYYY-MM-DD'),
    selectedIndividualTime: null,
    subscriptionStartDate: 'fromNow',
    selectedDate: moment().format('YYYY-MM-DD'),
    selectDateMin: moment().format('YYYY-MM-DD'),
    selectDateMax: moment().add(1, 'year').format('YYYY-MM-DD'),
  }),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    bpLevel() {
      const { bpLevel } = this.currentUser;

      if (!bpLevel || !bpLevel.isActive) {
        return null;
      }

      return {
        id: bpLevel.id,
        params: bpLevel.levelParams,
      };
    },
    showSelectsInterval() {
      return this.showSelects && this.durationIntervals.length > 1;
    },
    durationIntervals() {
      const params = this.UISettings.joinIndividualParams;

      if (params) {
        const arr = (params.lessonDurationType === 'unity') ? params.lessonDurations : this.cl.lessonDurations;
        return Array.from(new Set(arr.map(e => e.value))).sort((a, b) => (+a > +b ? 1 : -1));
      }
    },
    filialTzText() {
      if (this.cl) {
        const filial = this.filials.find(e => e.id === this.cl.filialId);
        const offset = moment().tz(filial.timezone).utcOffset() / 60;
        const translatedTz = langFilter(filial.timezone.toLowerCase());
        const str = `${translatedTz} (GMT ${offset >= 0 ? `+${offset}` : offset})`;
        return `Время указано по часовому поясу ${str}`;
      }
      return '';
    },
    canSelectLessons() {
      return this.cl.showSelectLessons;
    },
    getButtonsCond() {
      return this.cl && (
        (this.cl.courseId === 0 && this.completeIndividual)
        || (this.cl && this.cl.courseId !== 0)
        || (!this.canSelectLessons)
      );
    },
    canSkipTeachers() {
      return !this.individualData.teacherId && !this.selectedTeacherId
        && this.UISettings.joinIndividualParams.offerSkipTeachers
        && this.teachersFreeTime.length;
    },
    getPaymentFieldsVisibility() {
      if (!this.cl) {
        return false;
      }

      return this.cl.courseId !== 0
        || (this.cl.courseId === 0 && this.canSelectLessons && this.completeIndividual)
        || !!(this.cl.courseId === 0 && !this.canSelectLessons);
    },
    paymentSumLabel() {
      const minStr = this.joinPriceLimits.min.toLocaleString(this.lang);
      const maxStr = getMoneyStr(this.joinPriceLimits.max);
      return `Сумма оплаты (от ${minStr} до ${maxStr})`;
    },
    disableNextButton() {
      if (!this.selectedTeacherId) {
        return true;
      }

      if (!this.selectedIndividualTime
        && this.selectedIndividualTime !== 0
        && this.individualData.teacherId) {
        return true;
      }
      return false;
    },
    showBackButton() {
      if (this.UISettings.joinIndividualParams.skipTeachers && !this.individualData.time) {
        return false;
      }
      return true;
    },
    selectFilials() {
      const { disableJoinWithStatuses, joinStatusesDisabled: statusIds } = this.UISettings;
      let classIds = [];
      if (disableJoinWithStatuses) {
        classIds = this.currentUser.joins
          .filter(j => statusIds.includes(j.statusId)).map(e => e.classId);
      }

      const classes = this.classes
        .filter(cl => cl.status === 'opened'
          && (cl.freeRecords !== 0 || this.currentUser.joins.some(j => j.classId === cl.id)))
        .filter(cl => !classIds.includes(cl.id));


      return this.filials
        .filter(f => classes.some(cl => cl.filialId === f.id && f.status === 'active'))
        .slice()
        .sort((a, b) => (a.name > b.name ? 1 : -1));
    },
    selectedTeacherInfo() {
      const {
        date, teacherId, time, interval,
      } = this.individualData;
      const days = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
      const selectedDate = new Date(date);

      return `${this.managers.find(e => e.id === teacherId).name}, ${days[selectedDate.getDay()]},
       ${moment(date).format('DD.MM.YYYY')},
        ${time}-${DateHelper.getLessonEndTime(time, interval)}`;
    },
    selectClasses() {
      const { disableJoinWithStatuses, joinStatusesDisabled: statusIds } = this.UISettings;
      let classIds = [];
      if (disableJoinWithStatuses) {
        classIds = this.currentUser.joins
          .filter(j => statusIds.includes(j.statusId)).map(e => e.classId);
      }

      return this.classes
        .filter(cl => (cl.status === 'opened'
          && (cl.freeRecords !== 0 || this.currentUser.joins.some(j => j.classId === cl.id))))
        .filter(cl => !this.filialId || cl.filialId === this.filialId)
        .filter((cl) => { // Отфильтруем группы, которые уже начались.
          if (cl.showDates
            && cl.beginDate
            && !cl.allowRecords
            && this.UISettings.allowRecordsTimeout > 0) {
            const filial = this.filials.find(f => f.id === cl.filialId && f.status === 'active');
            const tzData = moment(cl.beginDate).tz(filial.timezone)
              .subtract(this.UISettings.allowRecordsTimeout, 'minutes');
            return tzData > moment();
          }
          return true;
        })
        .filter(cl => !classIds.includes(cl.id))
        .map((cl) => {
          cl.displayName = getClassName(cl.id);

          if (cl.payType === 'full') {
            cl.displayName += ` - ${getMoneyStr(cl.price)}`;
          }

          return cl;
        })
        .sort((a, b) => (a.displayName > b.displayName ? 1 : -1));
    },
    selectSubscriptionTypes() {
      if (this.notPayNow || !this.isOnlinePaymentEnabled || this.cl.payType === 'full') {
        return [];
      }

      let subscriptionTypes;

      const { subscriptionIds } = this.cl.onlinePayment;

      if (subscriptionIds.includes(-1)) {
        ({ subscriptionTypes } = this);
      } else {
        subscriptionTypes = this.subscriptionTypes.filter(({ id }) => subscriptionIds.includes(id));
      }

      const enabledSubs = subscriptionTypes.filter((sub) => {
        const byFilial = sub.filialIds.includes(this.cl.filialId) || sub.filialIds.includes(0);
        // Если мультиабонемент, то не сортируем по курсам
        if ((sub.courses && sub.courses.length) || (sub.classes && sub.classes.length)) {
          return byFilial && ((sub.courses.indexOf(-1) !== -1
            || sub.courses.indexOf(this.cl.courseId) !== -1
            || sub.classes.indexOf(this.cl.id) !== -1));
        }

        const { courseIds, classIds } = sub.onlinePayment;

        return byFilial && (courseIds.includes(-1) || courseIds.indexOf(this.cl.courseId) !== -1
          || classIds.indexOf(this.cl.id) !== -1);
      });
      const filial = this.filials.find(el => el.id === this.cl.filialId);
      return enabledSubs
        .filter(sub => subscriptionIds.includes(sub.id) || subscriptionIds.includes(-1))
        .map((sub) => {
          sub.displayName = getDisplayName(sub, filial);
          return sub;
        })
        .sort((a, b) => (a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1 : -1));
    },
    existingJoin() {
      if (this.currentUser && this.cl) {
        return this.currentUser.joins.find(join => join.classId === this.cl.id);
      }
      return null;
    },
    canJoin() {
      return (!this.existingJoin && this.cl)
        || (this.cl && this.existingJoin && this.lessonIds.length)
      || (this.cl && this.existingJoin && this.completeIndividual);
    },
    canJoinAndPay() {
      if (this.isShowIntegrationSelect && !this.integrationId) {
        return false;
      }

      if (this.existingJoin || !this.cl) {
        return false;
      }

      let isSumValid = true;

      if (this.summa) {
        isSumValid = this.summa >= this.joinPriceLimits.min
          && this.summa <= this.joinPriceLimits.max;
      }

      if (this.cl.payType === 'full') {
        return isSumValid;
      }

      const isSubStartDate = this.isShowSubscriptionBeginDateSelect
        ? !!this.subscriptionStartDate : true;

      return isSumValid && !!this.subscriptionType && isSubStartDate;
    },
    clOnlinePaymentForJoin() {
      return this.cl && this.isOnlinePaymentEnabled ? this.cl.onlinePayment.paymentForJoin : null;
    },
    onlinePaymentIntegrationsSelect() {
      if (!this.cl) {
        return [];
      }

      return this.onlinePaymentIntegrations
        .filter(({ filialIds }) => filialIds.includes(0) || filialIds.includes(this.cl.filialId))
        .sort((a, b) => (a.name > b.name ? 1 : -1));
    },
    isOnlinePaymentEnabled() {
      if (!this.cl || this.existingJoin || this.hasActiveSubscriptionForClass) {
        return false;
      }

      const isEnabled = this.onlinePaymentIntegrationsSelect
        && this.onlinePaymentIntegrationsSelect.length
        && this.allowOnlinePayment && this.cl.onlinePayment.enabled;

      if (this.cl.payType === 'full') {
        return isEnabled;
      }

      const { subscriptionIds } = this.cl.onlinePayment;

      let subscriptionTypes;

      if (subscriptionIds.includes(-1)) {
        ({ subscriptionTypes } = this);
      } else {
        subscriptionTypes = this.subscriptionTypes.filter(({ id }) => subscriptionIds.includes(id));
      }

      return subscriptionTypes.length && isEnabled;
    },
    isShowSubscriptionBeginDateSelect() {
      return this.selectSubscriptionTypes.length
        && this.subscriptionType
        && this.subscriptionType.onlinePayment.beginDateSelectEnabled
        && this.isOnlinePaymentEnabled;
    },
    userDiscount() {
      return this.userDiscounts.discount;
    },
    maxDiscount() {
      return this.userDiscounts.maxDiscount;
    },
    userDiscounts() {
      if (!this.cl) {
        return { discount: 0 };
      }

      let entity;
      let entityType;

      const discountAttr = this.currentUser.attributes.find(attr => attr.attributeAlias === 'discount');
      const initDiscount = discountAttr ? (+discountAttr.value || 0) : 0;

      if (this.cl.payType === 'full') {
        entity = this.cl;
        entityType = 'class';
      } else if (!this.subscriptionType) {
        return { discount: 0 };
      } else if (this.subscriptionType) {
        entity = this.subscriptionType;
        entityType = 'sub';
      }

      const { discount, maxDiscount } = calculateDiscount({
        entityType,
        entity,
        initDiscount,
        level: this.bpLevel,
      });

      return { discount, maxDiscount };
    },
    priceForJoin() {
      if (!this.cl) {
        return 0;
      }

      if (this.cl.payType === 'full') {
        return this.cl.price;
      }

      if (this.subscriptionType) {
        const filial = this.filials.find(el => el.id === this.cl.filialId);
        const sub = this.subscriptionTypes.find(el => el.id === this.subscriptionType.id);
        const updatedSub = getSubscriptionForPayment(sub, filial);
        return updatedSub.price;
      }

      return 0;
    },
    joinDiscount() {
      if (!this.cl || !this.userDiscount || !this.cl.useDiscount) {
        return 0;
      }

      if (this.userDiscount === 100) {
        return 0;
      }

      return Math.round(this.priceForJoin * (this.userDiscount) / 100);
    },
    joinPriceLimits() {
      if (!this.cl) {
        return {};
      }

      const result = {
        max: this.priceForJoin - this.joinDiscount,
      };

      const { partialPaymentForNewJoinMin, partialPaymentForNewJoin } = this.cl.onlinePayment;

      if (partialPaymentForNewJoin) {
        result.min = Math.round(result.max * +partialPaymentForNewJoinMin / 100);
      } else {
        result.min = result.max;
      }

      return result;
    },
    totalSum() {
      const {
        bonusesSumma,
        debitBonuses,
      } = this;

      const bonuses = debitBonuses ? +bonusesSumma || 0 : 0;
      let resultSum = this.priceForJoin - this.joinDiscount;

      if (this.summa) {
        resultSum = this.summa;
      }

      if (debitBonuses) {
        resultSum = resultSum - bonuses > 0 ? resultSum - bonuses : 0;
      }

      if (!this.debitFromBalans) {
        return resultSum;
      }

      return this.currentUser.availableBalance > resultSum ? 0
        : resultSum - this.currentUser.availableBalance;
    },
    payForJoinBtnText() {
      if (this.canJoinAndPay && this.totalSum === 0 && this.debitFromBalans) {
        return 'Списать средства с баланса';
      }

      if (this.canJoinAndPay && this.totalSum > 0 && this.debitFromBalans) {
        return 'Списать и перейти к оплате';
      }

      return 'Перейти к оплате';
    },
    createJoinAndPayBtnText() {
      if (this.canJoinAndPay && this.totalSum === 0 && this.debitFromBalans) {
        return 'Списать средства с баланса';
      }

      if (this.canJoinAndPay && this.totalSum > 0 && this.debitFromBalans) {
        return 'Списать и перейти к оплате';
      }

      return 'Записаться и перейти к оплате';
    },
    hasActiveSubscriptionForClass() {
      return this.cl
        && this.cl.payType === 'lessons'
        && this.userSubscriptions.find((sub) => {
          const subType = this.subscriptionTypes.find(t => t.id === sub.subscriptionId);
          return subType && subType.isMulti && sub.statusId === 2 && (
            sub.classIds.includes(this.cl.id)
              || sub.courseIds.includes(this.cl.courseId)
          );
        });
    },
    showNoNeedToPayReasonAlert() {
      return this.cl
        && (this.cl.courseId !== 0 || (this.cl.courseId === 0 && this.showSelects))
        && (this.existingJoin || this.hasActiveSubscriptionForClass);
    },
    isShowPriceInfo() {
      return this.isOnlinePaymentEnabled || (this.cl && this.cl.payType === 'full' && !this.existingJoin);
    },
    isShowPaymentSumInput() {
      return this.isOnlinePaymentEnabled
        && this.cl.onlinePayment.partialPaymentForNewJoin && !this.notPayNow;
    },
    isShowIntegrationSelect() {
      return this.isNeedIntegration && !(this.totalSum === 0 || +this.totalSum === 0);
    },
    isNeedIntegration() {
      return this.onlinePaymentIntegrationsSelect
        && this.onlinePaymentIntegrationsSelect.length > 1
        && this.isOnlinePaymentEnabled && !this.notPayNow;
    },
    ...mapGetters([
      'lang',
      'classes',
      'filials',
      'currentUser',
      'userSubscriptions',
      'UISettings',
      'onlinePaymentIntegrations',
      'subscriptionTypes',
      'allowOnlinePayment',
    ]),
  },
  methods: {
    clearBpPayloadData() {
      this.$set(this, 'debitBonuses', null);
      this.$set(this, 'availableBonuses', null);
      this.$set(this, 'bonusesSumma', null);
      this.showBonuses = false;
    },
    getBpEntityData() {
      if (this.cl && this.cl.payType === 'full') {
        return { entityType: 'class', entity: this.cl };
      } if (this.subscriptionType) {
        return { entityType: 'sub', entity: this.subscriptionType };
      }

      return {};
    },
    showBonusesBlock() {
      if (!this.currentUser) {
        return false;
      }

      const { bpLevel } = this.currentUser;

      if (!(bpLevel && bpLevel.isActive)) {
        return false;
      }

      const { entityType, entity } = this.getBpEntityData();

      if (!entityType || !entity) {
        return false;
      }

      const isValid = isValidEntityForBPLevel({
        entityType,
        entity,
        level: this.bpLevel,
        operationType: 'points',
      });

      if (!isValid) {
        return false;
      }

      this.calculateBonuses(entity, entityType);

      return isValid;
    },
    calculateBonuses(entity, entityType) {
      let price;

      const bonusesPaid = 0;

      // Если покупаем новое

      if (['sub', 'class'].includes(entityType)) {
        price = this.joinPriceLimits.max;
      }

      const initPrice = price;

      const availableBonuses = getAvailableBonusesSum({
        entity,
        entityType,
        level: this.bpLevel,
        balance: this.currentUser.bonusBalance,
        bonusesPaid,
        price,
        initPrice,
      });

      this.availableBonuses = availableBonuses;
      this.bonusesSumma = availableBonuses;
    },
    async closeOpenLink() {
      await loadBaseInfo();
      this.openLinkDialog = false;
      this.dialog = null;
    },
    allowedDates(value) {
      return this.lessons.some(l => l.date === value);
    },
    individualAllowedDates(value) {
      let isDateFrozen = false;
      if (this.frozenDates && this.frozenDates.length) {
        isDateFrozen = this.frozenDates.some(({ from, to }) => moment(value).isBetween(from, to, null, '[]'));
      }

      return (
        moment(value).isSameOrAfter(this.selectDateMin)
        && moment(value).isSameOrBefore(this.selectMaxDateIndividual)
        && !isDateFrozen
      );
    },
    canRecordThisTime(item) {
      return checkAllowRecord({
        beginTime: item.time,
        date: item.date,
        filialId: this.cl.filialId,
        classId: this.cl.id,
      }, this.currentUser);
    },
    changeFilial() {
      this.clearBpPayloadData();
      this.lessons = [];
      this.cl = null;
      this.completeIndividual = false;
    },
    changeInterval() {
      if (this.selectedTeacherId && this.selectedTeacherId !== -1) {
        this.selectedTeacherId = null;
      }
      this.loadTeachers();
    },
    changeSubscriptionType() {
      this.clearBpPayloadData();
      this.showBonuses = this.showBonusesBlock();
      this.subscriptionStartDate = 'fromNow';
    },
    async createJoin() {
      if (!this.cl) {
        return;
      }

      this.loading = true;

      try {
        if (!this.existingJoin) {
          // Записываем в группу
          const data = {
            userId: this.currentUser.id,
            classId: this.cl.id,
            lessonIds: this.lessonIds.length ? this.lessonIds : null,
            individualData: (!this.individualData.teacherId) ? null : this.individualData,
          };

          const result = await Join.createJoin(data);

          if (this.individualData.teacherId) {
            const indData = {
              userId: this.currentUser.id,
              classId: this.cl.id,
              ...this.individualData,
            };

            await LessonRecord.createIndividual(indData);
          }

          if (this.lessonIds.length && result.data.lessonsCount > 0) {
            this.setSnackInfoMessage(`Вы записались на ${result.data.lessonsCount} ${getLessonsWord(result.data.lessonsCount)}`);
          } else {
            this.setSnackInfoMessage('Вы успешно записались');
          }
        } else if (this.cl.courseId !== 0) {
          // Если просто записаться на занятия
          let successLessonsCount = 0;
          for (const lessonId of this.lessonIds) {
            try {
              await Lesson.createRecord({
                userId: this.currentUser.id,
                lessonId,
              });
              successLessonsCount += 1;
            } catch (e) {
              noop();
            }
          }
          if (successLessonsCount === 0) {
            this.setSnackErrorMessage('Запись невозможна. Пожалуйста, обновите страницу');
          } else {
            this.setSnackInfoMessage(`Вы записались на ${successLessonsCount} ${getLessonsWord(successLessonsCount)}`);
          }
        } else {
          const data = {
            ...this.individualData,
            classId: this.cl.id,
            userId: this.currentUser.id,
          };

          await LessonRecord.createIndividual(data);
          this.setSnackInfoMessage('Вы успешно записались на индивидуальное занятие');
        }
        await loadBaseInfo();
        this.dialog = false;
      } catch (e) {
        this.errorJoin = true;
        if (e.response && e.response.data) {
          let str;
          switch (e.response.data.message) {
            case 'AllRoomsAreBusy':
              str = 'Все аудитории заняты.';
              break;
            case 'TeacherNotFound':
              str = 'Преподаватель не найден.';
              break;
            case 'JoinRoomNotFound':
              str = 'Нет подходящей аудитории для записи.';
              break;
            case 'TeacherIsBusy':
              str = 'Преподаватель занят.';
              break;
            case 'RecordTimedOut':
              str = 'Запись на занятие закрыта';
              break;
            default:
              str = 'Запись невозможна.';
              break;
          }

          str += ' Пожалуйста, обновите страницу';

          this.setSnackErrorMessage(str);
        } else {
          this.setSnackErrorMessage('Запись невозможна. Пожалуйста, обновите страницу');
        }
        this.dialog = false;
      }

      this.loading = false;
    },
    nextIndividualStep() {
      if (this.selectedTeacherId && (this.selectedIndividualTime === null)) {
        this.prevSelectedTeacherId = this.selectedTeacherId;
        this.individualData.teacherId = this.selectedTeacherId;
        const teacherTime = (this.selectedTeacherId)
          ? this.teachersFreeTime.filter(e => e.teacherId === this.selectedTeacherId)
          : this.teachersFreeTime;

        this.updateSelectedIndividualDate(teacherTime);
        this.changeSelectedDate(this.selectedIndividualDate);
      } else if (this.selectedIndividualTime >= 0) {
        const { teacherId, date, time } = this.freeTimeDate[this.selectedIndividualTime];
        this.individualData.teacherId = teacherId;
        this.individualData.date = date;
        this.individualData.time = time;
        this.completeIndividual = true;
      }
      this.showSelects = false;
    },
    skipTeachers() {
      this.selectedTeacherId = -1;
      this.prevSelectedTeacherId = -1;
      this.individualData.teacherId = -1;
      this.updateSelectedIndividualDate(this.teachersFreeTime);
      this.selectDateMin = this.selectedIndividualDate;
      this.changeSelectedDate(this.selectDateMin);
      this.showSelects = this.UISettings.joinIndividualParams.skipTeachers;
    },
    goBack() {
      if (!this.completeIndividual) {
        this.selectedTeacherId = null;
        this.individualData.teacherId = null;
        this.selectedIndividualTime = null;
        this.updateSelectedIndividualDate(this.selectDateMin);
        this.showSelects = true;
      } else {
        if (this.UISettings.joinIndividualParams.skipTeachers
          || this.prevSelectedTeacherId === -1) {
          this.individualData.teacherId = -1;
          this.selectedTeacherId = -1;
          if (this.UISettings.joinIndividualParams.skipTeachers) {
            this.showSelects = true;
          } else {
            this.showSelects = false;
          }
        }

        this.completeIndividual = false;
        this.selectedIndividualTime = null;
        this.individualData.time = null;
      }
    },
    async createJoinAndPay() {
      if (!this.cl || this.existingJoin) {
        return;
      }

      this.loading = true;

      let createdJoin;
      const joinData = {
        classId: this.cl.id,
        userId: this.currentUser.id,
        summa: this.summa ? +this.summa : undefined,
        lessonIds: this.lessonIds.length ? this.lessonIds : null,
      };

      // Создадим запись
      try {
        ({ data: createdJoin } = await Join.createJoin(joinData));
        await loadBaseInfo();
      } catch (e) {
        this.dialog = false;
        this.loading = false;
        this.errorJoin = true;
        return;
      }

      if (this.cl.courseId === 0) {
        try {
          const data = {
            ...this.individualData,
            classId: this.cl.id,
            userId: this.currentUser.id,
          };

          await LessonRecord.createIndividual(data);
        } catch (e) {
          this.dialog = false;
          this.loading = false;
          this.errorJoin = true;
          return;
        }
      }

      this.integrationId = (this.isNeedIntegration && !this.isShowIntegrationSelect)
        ? this.onlinePaymentIntegrationsSelect[0].id : this.integrationId;
      // Создадим оплату для созданной запси
      const paymentData = {
        userId: joinData.userId,
        integrationId: this.integrationId,
        payload: {
          joinId: createdJoin.joinId,
          debitFromBalans: !!this.debitFromBalans,
          debitBonuses: !!this.debitBonuses,
          bonusesSumma: this.debitBonuses ? this.bonusesSumma || 0 : 0,
          summa: this.summa ? +this.summa : undefined,
          subscriptionStartDate: this.subscriptionStartDate,
          payFor: this.cl.payType === 'lessons' ? 'subForExistingJoin' : 'existingJoin',
          subscriptionId: this.subscriptionType ? this.subscriptionType.id : undefined,
        },
      };

      const sub = this.selectSubscriptionTypes
        .find(el => el.id === paymentData.payload.subscriptionId);
      if (sub && sub.type === 'dynamic') {
        const filial = this.filials.find(el => el.id === this.cl.filialId);
        const updatedSub = getSubscriptionForPayment(sub, filial);
        paymentData.payload.subscriptionVisitCount = updatedSub.visitCount;
      }

      if (window.ReactNativeWebView) {
        paymentData.payload.platform = getUserMobileAgent();
      }

      await this.makePayment(paymentData);

      await loadBaseInfo();

      this.loading = false;

      if (!this.openLinkDialog) {
        this.dialog = null;
      }

      this.dialog = false;
    },
    async payForJoin() {
      if (!this.cl || this.existingJoin) {
        return;
      }

      this.loading = true;

      this.integrationId = (this.isNeedIntegration && !this.isShowIntegrationSelect)
        ? this.onlinePaymentIntegrationsSelect[0].id : this.integrationId;

      const paymentData = {
        userId: this.currentUser.id,
        integrationId: this.integrationId,
        payload: {
          classId: this.cl.id,
          debitBonuses: !!this.debitBonuses,
          bonusesSumma: this.debitBonuses ? this.bonusesSumma || 0 : 0,
          debitFromBalans: !!this.debitFromBalans,
          summa: this.summa ? +this.summa : undefined,
          subscriptionStartDate: this.subscriptionStartDate,
          lessonIds: this.lessonIds.length ? this.lessonIds : null,
          payFor: this.cl.payType === 'lessons' ? 'subForNewJoin' : 'newJoin',
          subscriptionId: this.subscriptionType ? this.subscriptionType.id : undefined,
        },
      };

      if (this.cl.courseId === 0 && this.completeIndividual) {
        paymentData.payload.individualData = this.individualData;
      }

      const sub = this.selectSubscriptionTypes
        .find(el => el.id === paymentData.payload.subscriptionId);
      if (sub && sub.type === 'dynamic') {
        const filial = this.filials.find(el => el.id === this.cl.filialId);
        const updatedSub = getSubscriptionForPayment(sub, filial);
        paymentData.payload.subscriptionVisitCount = updatedSub.visitCount;
      }

      if (window.ReactNativeWebView) {
        paymentData.payload.platform = getUserMobileAgent();
      }

      await this.makePayment(paymentData);

      await loadBaseInfo();

      this.loading = false;
      this.dialog = false;
    },
    async makePayment(paymentData) {
      try {
        const { data } = await Payment.create(paymentData);

        if (data.result) {
          if (data.paymentProcessType === 'none') {
            this.setSnackInfoMessage('Вы успешно записаны');
          } else {
            if (data.paymentProcessType === 'redirect' && window.ReactNativeWebView) {
              this.openLinkDialog = true;
            }
            await initPaymentProcess(data);
          }
        } else if (data.error && data.error.message) {
          this.setSnackInfoMessage(data.error.message);
        } else {
          this.setSnackErrorMessage('Не удалось создать оплату. Пожалуйста, обновите страницу');
        }
      } catch (e) {
        if (e.response && e.response.data
          && e.response.data.error && e.response.data.error.message) {
          this.setSnackErrorMessage(e.response.data.error.message);
        } else {
          this.setSnackErrorMessage('Оплата невозможна. Пожалуйста, обновите страницу');
        }
      }
    },
    async classChange() {
      this.clearBpPayloadData();
      await this.loadLessons();
      this.setDefaultIntegration();
      this.notPayNow = false;
      this.debitFromBalans = false;
      this.subscriptionType = null;
      this.summa = undefined;
      this.completeIndividual = false;
      const intervals = this.durationIntervals;

      if (this.cl && this.cl.payType === 'full') {
        this.showBonuses = this.showBonusesBlock();
      }

      this.individualData = {
        teacherId: null,
        date: null,
        time: null,
        interval: intervals.length ? intervals[0] : null,
      };

      this.selectedIndividualTime = null;
      this.selectedTeacherId = null;
      this.selectedDate = null;

      if (this.selectSubscriptionTypes && this.selectSubscriptionTypes.length === 1) {
        this.subscriptionType = this.selectSubscriptionTypes[0];
        this.changeSubscriptionType();
      }

      if (this.cl.courseId === 0 && this.canSelectLessons) {
        await this.loadTeachers();
      }
    },
    changeSelectedDate(event) {
      this.freeTimeDate = this.teachersFreeTime.filter(e => e.date === event)
        .sort((a, b) => (moment(a.time, 'HH:mm') > moment(b.time, 'HH:mm') ? 1 : -1));

      if (this.individualData.teacherId > 0) {
        this.freeTimeDate = this.freeTimeDate
          .filter(e => e.teacherId === this.individualData.teacherId);
      }
      this.selectedIndividualTime = null;
    },
    getTeacherName(teacherId) {
      const m = this.managers.find(e => e.id === teacherId);
      if (m) {
        return m.name;
      }
      return '';
    },
    async loadTeachers() {
      const {
        joinIndividualParams: indParams,
        daysForRecordIndividual: daysCount,
      } = this.UISettings;

      this.managersLoaded = false;
      this.managers = [];

      const filter = {
        date: [moment().format('YYYY-MM-DD'),
          moment().add(daysCount, 'days').format('YYYY-MM-DD')],
        classId: this.cl.id,
        filialId: (this.filialId) ? this.filialId : this.cl.filialId,
        scopeUserId: this.currentUser.id,
        intervalDuration: this.individualData.interval,
      };
      const { data } = await Manager.getForIndividuals(filter);

      this.teachersFreeTime = [];

      data.individualManagers.forEach((e) => {
        if (this.individualData.interval) {
          const freeTime = e.freeTimeIntervals[this.individualData.interval] || [];
          freeTime.forEach((el) => {
            this.teachersFreeTime.push({
              time: el.time,
              date: el.date,
              interval: el.interval,
              name: e.name,
              teacherId: e.id,
            });
          });
        } else {
          e.freeTime.forEach((el) => {
            this.teachersFreeTime.push({
              teacherId: e.id,
              name: e.name,
              date: el.date,
              time: el.time,
            });
          });
        }
      });

      this.teachersFreeTime = this.teachersFreeTime.sort((a, b) => (a.date > b.date ? 1 : -1));

      this.allowedDatesIndividual = Array.from(new Set(this.teachersFreeTime.map(e => e.date)));
      this.managers = data.individualManagers;
      this.managersLoaded = true;

      if (indParams.skipTeachers) {
        this.selectedTeacherId = -1;
        this.skipTeachers();
      }
    },
    async loadLessons() {
      if (!this.cl || !this.cl.showSelectLessons) {
        return;
      }

      const { daysForRecord } = this.UISettings;

      this.lessonLoading = true;
      const filter = {
        date: [moment().format('YYYY-MM-DD'),
          moment().add(daysForRecord, 'days').format('YYYY-MM-DD')],
        classId: this.cl.id,
        filialId: this.filialId,
        scopeUserId: this.currentUser.id,
        includeRecords: true,
        includeFreezes: true,
        includeFreezeDates: true,
        statusId: 0,
        limit: 400,
        sort: 'date',
      };
      const result = await Lesson.fetch(filter);
      const { lessons, stats, frozenDates } = result.data;
      this.groupedLessons = [];
      this.lessons = lessons;
      this.frozenDates = frozenDates;
      lessons
        .sort((a, b) => {
          if (a.date > b.date) {
            return 1;
          }
          if (a.date < b.date) {
            return -1;
          }
          if (a.beginTime > b.beginTime) {
            return 1;
          }
          if (a.beginTime < b.beginTime) {
            return -1;
          }
          return 0;
        })
        .forEach((lesson) => {
          let group = this.groupedLessons.find(gr => gr.date === lesson.date);
          if (!group) {
            group = {
              id: lesson.id,
              date: lesson.date,
              displayDate: moment(lesson.date).locale('ru').format('dd, DD.MM'),
              lessons: [lesson],
            };
            this.groupedLessons.push(group);
          } else {
            group.lessons.push(lesson);
          }
        });
      this.stats = stats;
      this.lessonLoading = false;

      this.updateSelectedIndividualDate();
    },
    updateSelectedIndividualDate(freeTime) {
      let targetDate;
      if (_.isArray(freeTime)) {
        freeTime = freeTime.map(t => t.date);
        targetDate = freeTime[0];
      } else {
        targetDate = freeTime || moment().format('YYYY-MM-DD');
      }

      const isBetween = (date, { from, to }) => moment(date).isBetween(from, to, null, '[]');

      // Если заморозки нет или нужная дата в нее не попадает, то выставляем эту дату
      if (!(
        this.frozenDates && this.frozenDates.length
        && this.frozenDates.some(range => isBetween(targetDate, range))
      )) {
        this.selectedIndividualDate = targetDate;
        return;
      }


      // Выбираем ближайшее незамороженное время
      if (_.isArray(freeTime)) {
        // Ищем ближайшее время у преподавателя
        targetDate = freeTime.find(date => (
          this.frozenDates.every(range => !isBetween(date, range))
        ));
      } else {
        // Если препод не выбран, то просто первое свободное
        const sortedFreezes = this.frozenDates.sort((d1, d2) => (
          moment(d1.to).valueOf() - moment(d2.to).valueOf()
        ));

        const targetFreeze = sortedFreezes.find(({ to }) => {
          const dateToCheck = moment(to).add(1, 'days').format('YYYY-MM-DD');
          return sortedFreezes.every(range => !isBetween(dateToCheck, range));
        });

        targetDate = moment(targetFreeze.to).add(1, 'days').format('YYYY-MM-DD');
      }

      this.selectedIndividualDate = targetDate;
    },
    moveDate(date) {
      this.$vuetify.goTo(`#lesson-date-${date}`, {
        container: '#join-lesson-selector',
        // offset: this.join ? 360 : 300,
      });
    },
    setDefaultIntegration() {
      if (this.onlinePaymentIntegrationsSelect
        && this.onlinePaymentIntegrationsSelect.length === 1) {
        this.integrationId = this.onlinePaymentIntegrationsSelect[0].id;
      }
    },
    ...mapMutations(['setSnackInfoMessage', 'setSnackErrorMessage']),
  },
  created() {
    const { daysForRecord, daysForRecordIndividual } = this.UISettings;

    if (this.selectFilials.length === 1) {
      this.filialId = this.selectFilials[0].id;
    }

    this.selectMaxDateIndividual = moment().add(daysForRecordIndividual, 'day').format('YYYY-MM-DD');
    this.selectDateMax = moment().add(daysForRecord, 'day').format('YYYY-MM-DD');

    if (this.value && typeof this.value === 'object') {
      this.filialId = this.value.filialId;
      this.changeFilial();

      this.cl = this.value.cl;
      this.classChange();

      this.lessonIds = this.value.lessonIds;
      this.lessons = this.value.lessons;
    }
  },
};
</script>

<style scoped>

#join-lesson-selector {
  max-height: 210px;
  overflow: scroll;
  border: 1px solid #aaaaaa;
  padding: 5px
}

#free-time-selector {
  max-height: 200px;
  overflow: scroll;
  border: 1px solid #aaaaaa;
  overflow-x: hidden;
}

.min-height {
  min-height: 115px;
}

.free-time-item {
  width: 31.3%;
  margin-left: 1%;
  margin-right: 1%;
  flex: none !important;
}

.free-time-item-content {
  padding: 10px 0 10px 0;
  height: 100%;
  width: 100%;
}

.free-time-container {
  display: flex;
  flex-wrap: wrap;
}

.break-word {
  word-break: break-word;
  white-space: initial;
  text-align: center;
}

@media (max-width: 590px) {
  .free-time-item {
    width: 48%;
  }
}

</style>
